module.exports = __webpack_public_path__ + "img/map.573105f3.png";